import { jsx as _jsx } from "react/jsx-runtime";
import { darken, lighten, useTheme } from '@material-ui/core/styles';
import { LinearProgress } from '@material-ui/core';
export function MLinearProgress({ color = 'primary', sx, ...other }) {
    const theme = useTheme();
    const isLight = theme.palette.mode === 'light';
    const gradientDashed = (color) => {
        const getColor = isLight ? lighten(color, 0.62) : darken(color, 0.5);
        return `radial-gradient(${getColor} 0%, ${getColor}  16%, transparent 42%)`;
    };
    if (color === 'inherit' || color === 'primary' || color === 'secondary') {
        return _jsx(LinearProgress, Object.assign({ color: color, sx: sx }, other), void 0);
    }
    return (_jsx(LinearProgress, Object.assign({ sx: {
            '& .MuiLinearProgress-bar': {
                bgcolor: theme.palette[color].main,
            },
            '& .MuiLinearProgress-dashed': {
                backgroundImage: gradientDashed(theme.palette[color].main),
            },
            ...sx,
        } }, other), void 0));
}
//# sourceMappingURL=MLinearProgress.js.map